export default __webpack_public_path__ + "static/media/ecom.34544e0c.png";